/* eslint-disable @typescript-eslint/return-await */
/* eslint-disable @typescript-eslint/no-unused-vars */
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_PROD,
});

export const useApi = () => ({
  validateToken: async (token: string) => {
    //remover fake token valido
    return {
      user: { id: 3, name: 'jose', email: 'jose@gmail.com' },
    };
    // const reponse = await api.post('/validate', { token });
    // return reponse.data;
  },
  signin: async (email: string, password: string) => {
    return await api
      .post('auth/login', {
        email: email,
        password: password,
      })
      .then((res) => res.data);
  },
  logout: async () => {
    //fake remover
    return { status: true };
    // return await api.post('/logout');
    // return response.data;
  },

  get: async (url) => {
    return await api
      .get(url, {
        headers: { Authorization: sessionStorage.getItem('authToken') },
      })
      .then((res) => res.data);
  },

  post: async (url, data) => {
    return await api
      .post(url, data, {
        headers: { Authorization: sessionStorage.getItem('authToken') },
      })
      .then((res) => res.data);
  },

  file: async (url, data, header) => {
    return await api
      .post(url, data, {
        headers: {
          Authorization: sessionStorage.getItem('authToken'),
          'content-type': 'multipart/form-data',
          'content-length': header.content_length,
        },
      })
      .then((res) => res.data);
  },

  delete: async (url) => {
    return await api
      .delete(url, {
        headers: { Authorization: sessionStorage.getItem('authToken') },
      })
      .then((res) => res.data);
  },

  patch: async (url, data) => {
    return await api
      .patch(url, data, {
        headers: { Authorization: sessionStorage.getItem('authToken') },
      })
      .then((res) => res.data);
  },
});
